module.exports = __webpack_public_path__ + "img/66a8069.svg";